import * as React from "react"
import {Box} from "@mui/material";

import {LabelValueText} from "@components";


export default function RepricingAlertCardRowBasic({ label, value }) {
	return <Box sx={{ width: 1, pl: 1 }}>
		<LabelValueText label={label} value={value} />
	</Box>
}